import React, { useContext, useState } from 'react'
import MainLayout from '../../components/MainLayout'
import Link from '../../components/Link'
import { get } from 'lodash'
import { format } from 'date-fns'
import { is } from 'date-fns/locale'
import Img from 'gatsby-image'
import { hyphenate } from '../../utils'
import { LanguageContext } from '../../context'
import styles from './NewsPage.module.scss'

const Cmp = data => {
  const { currentLang: language } = useContext(LanguageContext)
  const newsArr = language === 'is' ? data.isNews.edges : data.enNews.edges
  const newsLink = language === 'is' ? '/frettir/' : '/en/news/'

  const [itemsToShow, setItemsToShow] = useState(10) // Initial number of items to show

  const loadMore = () => {
    setItemsToShow(prevItemsToShow => prevItemsToShow + 10) // Increase the number of items by 10
  }

  const currentItems = newsArr.slice(0, itemsToShow) // Get the current items

  return (
    <MainLayout topSpacing>
      <div className='container'>
        <div className='news-summaries vspace-l-top'>
          {currentItems.map(x => {
            const {
              date,
              excerpt,
              featured_media,
              slug,
              title
            } = x.node

            const imageProps = get(featured_media, 'localFile.childImageSharp.fixed', {})
            const formattedDate = format(new Date(date), 'dd.MM.yyyy - HH:mm', { locale: is })

            return (
              <article className='row news-summary-vertical'>
                <div className='col-md-4 pb-3'>
                  <Img fluid={imageProps} />
                </div>
                <div className='col-md-7'>
                  <span className='field-content'>
                    <h3>
                      <span className='ss-calendar' /> {formattedDate}
                    </h3>
                  </span>
                  <span className='field-content'>
                    <h2>
                      <Link to={`${newsLink}${slug}`}>
                        {hyphenate(title)}
                      </Link>
                    </h2>
                  </span>
                  <div
                    className='field-content'
                    dangerouslySetInnerHTML={{ __html: excerpt }} />
                </div>
              </article>
            )
          })}
        </div>
        <div className={styles.see_more_container}>
          {itemsToShow < newsArr.length && // Show the "See more" button only if there are more items to show
            <button onClick={loadMore} className={styles.more_button} ><span>{language === 'is' ? 'Sjá meira' : 'See more'}</span></button>
          }
        </div>
      </div>
    </MainLayout>
  )
}

export default Cmp
